'use client';

interface LoadingSpinnerProps {
  size?: number;
  className?: string;
}

export default function LoadingSpinner({ size = 24, className = '' }: LoadingSpinnerProps) {
  return (
    <div
      className={`inline-block animate-spin rounded-full border-4 border-loading-spinner-border border-l-loading-spinner-border-l ${className}`}
      style={{
        width: size,
        height: size,
      }}
      role="status"
      aria-label="Loading"
    />
  );
}
